var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7C9.44772 7 9 7.44772 9 8V40C9 40.5523 9.44772 41 10 41H22C22.5523 41 23 40.5523 23 40V8C23 7.44772 22.5523 7 22 7H10ZM20.5 25.5C21.3284 25.5 22 24.8284 22 24C22 23.1716 21.3284 22.5 20.5 22.5C19.6716 22.5 19 23.1716 19 24C19 24.8284 19.6716 25.5 20.5 25.5Z",
    fill: "#039BE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 7C25.4477 7 25 7.44772 25 8V40C25 40.5523 25.4477 41 26 41H38C38.5523 41 39 40.5523 39 40V8C39 7.44772 38.5523 7 38 7H26ZM35.5 25.5C36.3284 25.5 37 24.8284 37 24C37 23.1716 36.3284 22.5 35.5 22.5C34.6716 22.5 34 23.1716 34 24C34 24.8284 34.6716 25.5 35.5 25.5Z",
    fill: "#039BE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockers);
export default ForwardRef;